module.exports = __webpack_public_path__ + "static/media/s_rhythmic_gym.7c244067.mp3";